<template>
  <div id="section-header">
    <section-header />
  </div>
</template>

<script>
  import SectionHeader from "./components/Header";

  export default {
    name: "Section-Header",
    components: {
      SectionHeader
    }
  };
</script>


